<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="영어단어의 의미를 파악합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="ww-jumbotron-content lg:p-8 md:p-6 sm:p-4 p-4 mb-6 rounded-lg text-center" >
        <h1 class="mb-1 text-primary">{{ content.translation}}</h1>
      </div>
      <!-- <vs-divider color="primary"> </vs-divider> -->
      <div class="ww-jumbotron-content lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg text-center">
        <input class="ml-2 mr-2 tc-ww-input" ref="inputUser" v-model="inputData" v-on:keyup.enter="onEnter" :placeholder="hint ? content.sentence : ''" :maxlength="content.sentence.length" />
      </div>
    
      <div class="text-center">
        <audio ref="audioPlayer" 
          controls 
          hidden
          v-on:ended="audioFinish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>  
    </vx-card>

    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      hint: false,
      contentIndex: 0,
      inputData: '',
      retryCount: 0,
      studyFinished: false
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    },
    userInput () {
      return this.$refs['inputUser']
    }
  },
  methods: {
    onReload () {
      this.hint = false
      this.hintUseNum = 0
      this.contentIndex = 0
      this.retryCount = 0
      this.inputData = ''
    },
    onEnter () {
      
      if (this.inputData.length === 0) return

      if (this.inputData === this.content.sentence) {
        this.correct()
        this.playAudio(this.audioPlayer, this.content.audio)
      } else {
        this.inCorrect()
        this.retryCount++
        if (this.retryCount < this.retry) {
          setTimeout(function () {
            this.inputData = ''
          }.bind(this), 2000)
        } else {
          setTimeout(function () {
            this.onQuestion()
          }.bind(this), 2000)
        }
      }
      // question / answer / userAnswer
      this.addResult(this.content.sentence, this.content.sentence, this.inputData)
    },
    playAudio (audioPlayer, src) {
      if (this.studyFinished) return
      audioPlayer.src = src
      audioPlayer.play()
    },
    onHint () {
      if (this.hintUseNum >= this.hintCount) {
        this.finishHintDlg()
      } else {
        this.hintUseNum++
        this.hint = true
      }
      this.userInput.focus()
    },
    onStart () {
      this.hint = false
      this.retryCount = 0
      this.inputData = ''
    },
    onQuestion () {
      if (this.contentIndex === (this.contentsLen - 1)) {
        this.onComplete()
      } else {
        this.contentIndex++
        this.onStart()
      }
    },
    audioFinish () {
      this.onQuestion()
    },
    startAlert () {
      this.startStudyDlg('영어단어의 의미를 파악합니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content {
    border:1px solid #7367F0;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>